import { render, staticRenderFns } from "./CommunicationPanel.vue?vue&type=template&id=d108b794&scoped=true"
import script from "./CommunicationPanel.vue?vue&type=script&lang=js"
export * from "./CommunicationPanel.vue?vue&type=script&lang=js"
import style0 from "./CommunicationPanel.vue?vue&type=style&index=0&id=d108b794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d108b794",
  null
  
)

export default component.exports